<
<template>
	<button
		@click.stop="openNotifications"
		class="user-notifications__toggle"
		data-ignore-click-outside="true"
	>
		<svg class="user-notifications__toggle__icon" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_294_2714)">
				<path d="M20.6754 12.5234L18.9337 6.25705C18.4232 4.42127 17.3137 2.80881 15.7816 1.67598C14.2495 0.543144 12.3827 -0.0450501 10.4779 0.00488997C8.57313 0.0548301 6.73969 0.740038 5.26904 1.9516C3.79839 3.16316 2.77492 4.83154 2.36132 6.69155L1.0129 12.7553C0.863956 13.4253 0.867399 14.1202 1.02298 14.7888C1.17855 15.4573 1.48229 16.0823 1.91177 16.6177C2.34124 17.1531 2.88549 17.5853 3.50432 17.8822C4.12315 18.1791 4.80077 18.3332 5.48715 18.3332H6.50832C6.71871 19.3693 7.28082 20.3008 8.09941 20.9699C8.91801 21.639 9.94274 22.0045 11 22.0045C12.0572 22.0045 13.082 21.639 13.9006 20.9699C14.7191 20.3008 15.2813 19.3693 15.4916 18.3332H16.2598C16.9664 18.3333 17.6634 18.1699 18.2964 17.856C18.9294 17.5421 19.4813 17.0861 19.9089 16.5236C20.3365 15.9611 20.6283 15.3073 20.7614 14.6134C20.8945 13.9195 20.8654 13.2042 20.6763 12.5234H20.6754ZM11 20.1665C10.4332 20.1642 9.88107 19.9868 9.41901 19.6586C8.95695 19.3305 8.60756 18.8675 8.41865 18.3332H13.5813C13.3924 18.8675 13.043 19.3305 12.581 19.6586C12.1189 19.9868 11.5667 20.1642 11 20.1665V20.1665ZM18.4488 15.4136C18.1934 15.7525 17.8624 16.0271 17.4823 16.2157C17.1021 16.4042 16.6832 16.5016 16.2589 16.4999H5.48715C5.07537 16.4998 4.66886 16.4073 4.29763 16.2291C3.9264 16.0509 3.59992 15.7916 3.3423 15.4704C3.08467 15.1491 2.90248 14.7741 2.80916 14.3731C2.71585 13.972 2.71379 13.5551 2.80315 13.1531L4.15065 7.08846C4.47547 5.62749 5.27935 4.31702 6.43448 3.36537C7.58962 2.41373 9.02972 1.87554 10.5259 1.83634C12.022 1.79715 13.4883 2.2592 14.6917 3.14906C15.8951 4.03891 16.7664 5.3055 17.1673 6.74746L18.909 13.0138C19.0241 13.4221 19.0424 13.8515 18.9625 14.2681C18.8826 14.6847 18.7067 15.0769 18.4488 15.4136V15.4136Z" fill="none"/>
			</g>
		</svg>

		<span class="visible-desktop">{{ $t("nav.notifications") }}</span>
		<span v-show="unread" class="user-notifications__toggle__count">{{
			unread
		}}</span>
	</button>
</template>

<script>
export default {
	name: "name",
	data() {
		return {
			unread: 0,
		};
	},
	watch: {
		unread(n, o) {
			if (n < 0) this.unread = 0;
		},
	},
	mounted() {
		let vm = this;
		if (vm.$auth.getAuthStatus()) {
			// vm.getNotificationCount();
			vm.attachEvents();
		}
	},
	methods: {
		openNotifications() {
			if (!this.$auth.getAuthStatus()) {
				return this.$router.push(`/login?next=/notifications`);
			}
			this.$router.push(`/notifications`);
		},
		getNotificationCount() {
			let vm = this;
			let payload = {
				profile_id: vm.$auth.getUser()["id"],
				token: vm.$auth.getToken(),
			};
			vm.$http
				.post(`${NOTIFICATIONS_API_URL}notifications_count`, payload)
				.then((res) => {
					vm.unread = res.data[0].total_count;
				})
				.catch((err) => {});
		},
		attachEvents() {
			let vm = this;
			window.addEventListener("newNotification", vm.handleNewNotificationEvent);
			window.addEventListener(
				"readNotification",
				vm.handleReadNotificationEvent
			);
			window.addEventListener(
				"readAllNotification",
				vm.handleReadAllNotificationEvent
			);
		},
		handleReadAllNotificationEvent() {
			let vm = this;
			vm.unread = 0;
			vm.getNotificationCount();
		},
		handleNewNotificationEvent() {
			let vm = this;
			vm.unread += 1;
			vm.getNotificationCount();
		},
		handleReadNotificationEvent() {
			let vm = this;
			vm.unread -= 1;
			vm.getNotificationCount();
		},
	},
};
</script>

<style lang="scss">
.user-notifications__toggle {
	background: none;
	border: none;
	cursor: pointer;
	outline: none;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 0;
	margin-left: 10px;
	font-size: var(--font-medium);
	font-weight: var(--font-weight-lighter);
	@media (min-width: 1023px) {
		flex-direction: row;
		margin-right: 10px;
	}
	&__icon {
		width: 22px;
		
			path{
				fill: var(--black);
			}
		
		@media (min-width: 1023px) {
			width: 15px;
			margin-right: 5px;
		}
	}
	&__count {
		color: var(--yellow);
		font-weight: var(--font-weight-medium);
		font-size: var(--font-large);
		position: absolute;
		color: var(--white);
		font-size: var(--font-small);
		border-radius: 50%;
		height: 20px;
		width: 20px;
		line-height: 21px;
		background: var(--dark-blue);
		top: -2px;
		font-size: var(--font-smallest);
		right: 2px;
	}
	&:hover {
		opacity: 0.9;
	}
}
</style>
